import React, { useState, useEffect } from "react";
import styles from "./AutoRenewModal.module.css";
import NumberComponent from "../NumberComponent";
// import FetchWithToken from "../FetchWithToken/FetchWithToken";
import { toast } from "react-toastify";
import { AuthContext } from "../../Constants/AuthProvider";
import { apiUrl } from "../../Constants/Constants";
import { useFetchWithToken } from "./../FetchWithToken/FetchWithToken";
import Loading from "./../Loading/Loading.module";
import CheckBox from "../CheckBox/CheckBox.module";
import CtaBtns from "../CtaBtns/CtaBtns.module";
const AutoRenewModal = ({
  isOpen,
  onClose,
  fetchAutoRenewableAccounts,
  getInfo,
}) => {
  const { loading, fetchWithToken } = useFetchWithToken();
  const [accounts, setAccounts] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const { onLogout } = React.useContext(AuthContext);

  const formatPrice = (price) => {
    if (price == null) return "در حال بارگذاری...";
    return `${price.toLocaleString("fa-IR")} تومان`;
  };

  const autoRenewActivate = () => {
    const former = new FormData();
    former.append("selectedAccounts", selectedAccounts);

    fetchWithToken(
      apiUrl + "user/auto-renew",
      {
        method: "POST",
      },
      former
    ).then((data) => {
      if (data.status === "200") {
        onClose(true);
        getInfo();
        toast.success("تغییرات با موفقیت اعمال گردید.");
      }

      // setReceivedData(data.data);

      if (data.status === "401") {
        onLogout();
      }
    });
  };
  // دریافت اکانت‌های قابل تمدید خودکار
  useEffect(() => {
    if (isOpen) {
      const loadAccounts = async () => {
        const data = await fetchAutoRenewableAccounts();
        setSelectedAccounts([]);
        const filteredAccounts = data?.filter((account) => account.price != 0);
        setAccounts(filteredAccounts);
        filteredAccounts?.forEach((item) => {
          if (item.autorenew) {
            setSelectedAccounts((prev) => [...prev, item.id]);
          }
        });
      };

      loadAccounts();
    }
  }, [isOpen, fetchAutoRenewableAccounts]);

  //   useEffect(() => {
  //     if (isOpen) {
  //       const loadAccounts = async () => {
  //         const data = await fetchAccounts();
  //         const filteredAccounts = data.filter(
  //           (account) => account.remainingTime < 2 && account.price != 0
  //         );
  //         setAccounts(filteredAccounts);
  //       };
  //       loadAccounts();
  //     }
  //   }, [isOpen, fetchAccounts]);

  // مدیریت انتخاب/عدم انتخاب اکانت
  const handleSelect = (accountId) => {
    setSelectedAccounts(
      (prev) =>
        prev.includes(accountId)
          ? prev.filter((id) => id !== accountId) // حذف از لیست انتخاب‌شده
          : [...prev, accountId] // افزودن به لیست انتخاب‌شده
    );
  };

  if (!isOpen) return null;

  return (
    <div className={styles.custommodaloverlay} onClick={onClose}>
      <div
        className={styles.custommodalcontent}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.topBoxIcons}>
          <div className={styles.rightIconTop}>
            <i class="fa-solid fa-money-bill"></i>
          </div>
          <button className={styles.custommodalclose} onClick={() => onClose()}>
            ×
          </button>
        </div>
        <div className={styles.renewtitle}>تمدید خودکار اکانت‌ها</div>
        {/* <p className={styles.descrenew}>
          کاربر گرامی، با افزایش موجودی کیف پول خود میتوانید سرویس تمدید خودکار
          را برروی اکانت های خود فعال نمایید. پس از فعالسازی این سرویس،‌ در موعد
          تمدید اکانت های انتخابی شما، به طور خودکار، مبلغ تمدید از موجودی کیف
          پول شما کسر خواهد شد.
          <br />
          لطفا توجه داشته باشید، در صورت عدم موجودی، اکانت هایی که موفق به تمدید
          نشدند غیرفعال خواهند شد.
        </p> */}
        <div className={styles.accountlist}>
          {accounts?.map((account) => (
            <div
              key={account.id}
              className={`${styles.accountcard} ${
                selectedAccounts.includes(account.id) ? styles.selected : ""
              }`}
              onClick={() => handleSelect(account.id)}
            >
              <CheckBox checked={selectedAccounts.includes(account.id)} />

              {/* <p className={styles.price}>{formatPrice(account.price)}</p> */}
              <p className={styles.remainingtime}>
                {NumberComponent(account.remainingTime.days)} روز مانده
              </p>
              <div className={styles.accountnames}>
                {account.accountName}
                <i class="far fa-user"></i>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.modalactions}>
          <CtaBtns
            className={styles.gonext}
            onAtion={() => autoRenewActivate()}
            // disabled={selectedAccounts.length === 0}
          >
            ذخیره تغییرات
          </CtaBtns>
        </div>
      </div>
      {loading && <Loading />}
    </div>
  );
};

export default AutoRenewModal;
